import { addMessages } from '@hana/i18n';

// Khoá chuỗi soa.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'soa.1': "Ngày",
  'soa.2': "Chứng từ",
  'soa.3': "Diễn giải",
  'soa.4': "Phát sinh",
  'soa.5': "Đã trả",
  'soa.6': "Còn",
  'soa.7': "Thanh toán",
  'soa.8': "Lịch sử thanh toán",
  'soa.9': "Phải thu đại lý",
  'soa.10': "Phải trả đại lý",
  'soa.11': "Bù trừ công nợ",
  'soa.12': "Tuổi nợ phải trả",
  'soa.13': "Chứng từ đối chiếu tháng",
  'soa.14': "Duyệt chứng từ đối chiếu tháng 10",
});
addMessages('en', {
  'soa.1': "Date",
  'soa.2': "Document",
  'soa.3': "Description",
  'soa.4': "Incurred",
  'soa.5': "Paid",
  'soa.6': "Balance",
  'soa.7': "Payment",
  'soa.8': "Payment history",
  'soa.9': "Agent receivable",
  'soa.10': "Agent payable",
  'soa.11': "Offset balances",
  'soa.12': "Payable aging",
  'soa.13': "Monthly reconciliation documents",
  'soa.14': "Approve October reconciliation documents",
});
